import { format } from 'date-fns';
import { fr } from 'date-fns/locale';

export const formatDossierDate = (dateStr: string): string => {
  try {
    return format(new Date(dateStr), 'dd/MM/yyyy', { locale: fr });
  } catch {
    return dateStr;
  }
};
